module.exports = __webpack_public_path__ + "static/media/batterybucks-logo.f62a5751.svg";